export function parseAiConversationId(conversationId: string) {
  const i = conversationId.indexOf(":");

  if (i === -1) return { userId: null, uuid: null };

  return {
    userId: conversationId.slice(0, i),
    uuid: conversationId.slice(i + 1),
  };
}
